import {
  ExtractFnReturnType,
  MutationConfigType,
  useMutation,
  UseMutationResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiManagersEmployeeConditionSurveysMutateRequestType,
  ApiManagersEmployeeConditionSurveysMutateResponseType,
} from "~/domains";

type RequestDataType = {
  employeeConditionSurvey: ApiManagersEmployeeConditionSurveysMutateRequestType;
};

const request = async ({
  employeeConditionSurvey,
}: RequestDataType): Promise<ApiManagersEmployeeConditionSurveysMutateResponseType> => {
  const response =
    await new ApiClient().post<ApiManagersEmployeeConditionSurveysMutateResponseType>(
      "/api/managers/employee_condition_surveys",
      { employee_condition_survey: employeeConditionSurvey },
    );
  return response.data;
};

type MutationFnType = typeof request;

type PropsType = {
  config?: MutationConfigType<MutationFnType>;
};

export const useApisManagersEmployeeConditionSurveysCreate = ({
  config = {},
}: PropsType = {}): UseMutationResult<
  ApiManagersEmployeeConditionSurveysMutateResponseType,
  RequestDataType
> => {
  return useMutation<ExtractFnReturnType<MutationFnType>, RequestDataType>(
    request,
    {
      ...config,
    },
  );
};
